import { ExternalLink, Play } from "lucide-react";
import { useRef, useState } from "react";
import videoPoster from "../../assets/landing/video-poster.jpg";
import "./LandingVideo.css";

/**
 * The apresentação video. Nothing reaches YouTube before the visitor presses
 * play: the poster is a local asset and the iframe only enters the document on
 * activation. The embed is the nocookie host, and the same page load never
 * returns to the poster.
 */
const VIDEO_ID = "ANxI29SSbZY";
const VIDEO_TITLE =
  "Vídeo de apresentação do Acertei Questões: Conheça a nossa plataforma";
const WATCH_URL = `https://youtu.be/${VIDEO_ID}`;
const EMBED_URL =
  `https://www.youtube-nocookie.com/embed/${VIDEO_ID}` +
  "?autoplay=1&rel=0&modestbranding=1&playsinline=1";

export default function LandingVideo() {
  const [tocando, setTocando] = useState(false);
  const frameRef = useRef<HTMLIFrameElement | null>(null);

  return (
    <section aria-label="video" className="lvid">
      <div className="lvid__deco" aria-hidden="true">
        <div className="lvid__orb" />
        <div className="lvid__gem" />
      </div>

      <div className="lvid__inner">
        <header className="lvid__header">
          <p className="lvid__eyebrow">APRESENTAÇÃO</p>
          <h2 className="lvid__title">Veja como o Acertei funciona</h2>
          <p className="lvid__lead">
            Um vídeo curto sobre como treinar por questões, fazer simulados e acompanhar seu desempenho.
          </p>
        </header>

        <div className="lvid__stage">
          <div className="lvid__player">
            {tocando ? (
              <iframe
                ref={frameRef}
                className="lvid__frame"
                src={EMBED_URL}
                title={VIDEO_TITLE}
                referrerPolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            ) : (
              <button
                type="button"
                className="lvid__cover"
                aria-label="Reproduzir vídeo de apresentação: Conheça a nossa plataforma, 1 minuto e 30 segundos"
                onClick={() => {
                  setTocando(true);
                  // The iframe mounts in this same commit; focus it once it exists.
                  window.requestAnimationFrame(() => frameRef.current?.focus());
                }}
              >
                <img
                  className="lvid__poster"
                  src={videoPoster}
                  alt=""
                  width={1280}
                  height={720}
                />
                <span className="lvid__play">
                  <Play className="lvid__play-icon" aria-hidden="true" fill="currentColor" size={28} />
                </span>
                <span className="lvid__duration">1:30</span>
              </button>
            )}
          </div>
        </div>

        <p className="lvid__watch">
          <a
            className="lvid__watch-link"
            href={WATCH_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ExternalLink aria-hidden="true" size={16} />
            Assistir no YouTube
            <span className="lvid__sr">(abre em uma nova aba)</span>
          </a>
        </p>
      </div>
    </section>
  );
}
